

































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { datetime } from '@/utils/filter';
import TextHighlighter from './TextHighlighter.vue';
import { SearchAllParams, YqApi } from '../yqRequest';

@Component({ components: { TextHighlighter } })
export default class SearchList extends Vue {
  @Prop() query: SearchAllParams;

  searchParams: { pageSize: number; offset: number } = {
    pageSize: 30,
    offset: 0,
  };

  loading = true;

  listData = [];

  pagination = {
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['30', '60', '90', '100'],
    total: 0,
    pageSize: 30,
    onChange: this.onPageChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  onPageChange(page: number) {
    this.pagination.current = page;
    this.searchParams.offset = (page - 1) * this.pagination.pageSize;
    // 根据更新后的搜索参数执行查询操作
    this.getList();
  }
  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = current;
    this.pagination.pageSize = Number(pageSize);
    this.searchParams.pageSize = Number(pageSize);
    this.searchParams.offset = (current - 1) * Number(pageSize);
    // 根据更新后的搜索参数执行查询操作
    this.getList();
  }

  toDetail(records: any) {
    // this.$router.push({
    //   path: '/search/detail',
    //   query: { id: records.id, keywords: this.query.keywords },
    // });
    window.open(
      this.$router.resolve({
        path: '/search/detail',
        query: { id: records.id, keywords: records.redKeyWord, index: records.index },
      }).href,
      '_blank'
    );
  }

  async getList() {
    this.loading = true;
    try {
      const res = await YqApi.searchAll({ ...this.query, ...this.searchParams });
      const countData = await YqApi.mediaCount({ ...this.query, ...this.searchParams });
      this.pagination.total = countData.mediaCount[0];
      this.listData = res.records;
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.$message.error(error.message ?? error.toString());
      this.loading = false;
    }
  }

  onSearch() {
    this.searchParams.offset = 0;
    this.pagination.current = 1;
    this.getList();
  }

  mounted() {
    // this.getList();
  }
}
